import {
  LicenseDescription,
  LicenseInfoContainer,
  LicenseSectionContainer,
  LicenseTitle,
} from './styled';

type PropsType = {
  title: string;
  description: string;
};

const LicenseInfoSection = ({ title, description }: PropsType) => (
  <LicenseSectionContainer>
    <LicenseInfoContainer>
      <LicenseTitle>{title}</LicenseTitle>
      <LicenseDescription>{description}</LicenseDescription>
    </LicenseInfoContainer>
  </LicenseSectionContainer>
);

export default LicenseInfoSection;
